import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export const Field = ({ label, icon: Icon, trailing, className, inputClassName, ...props }) => (
  <label className="block">
    <span className="block text-[12.5px] font-semibold text-slate-700 mb-1.5 tracking-[0.01em]">{label}</span>
    <div className={cn('relative group', className)}>
      {Icon && <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-[17px] h-[17px] text-slate-400 group-focus-within:text-[#3A6AFF] transition-colors pointer-events-none" strokeWidth={1.9} />}
      <input
        {...props}
        className={cn(
          'w-full h-11 rounded-xl border border-slate-200 bg-slate-50/70 text-[14.5px] text-slate-900 placeholder:text-slate-400',
          'outline-none transition-[border-color,background-color,box-shadow] duration-200',
          'hover:border-slate-300 focus:bg-white focus:border-[#3A6AFF] focus:shadow-[0_0_0_4px_rgba(58,106,255,0.14)]',
          Icon ? 'pl-11' : 'pl-4',
          trailing ? 'pr-11' : 'pr-4',
          inputClassName,
        )}
      />
      {trailing && <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center">{trailing}</div>}
    </div>
  </label>
);

export const PrimaryButton = ({ loading, loadingLabel, children, className, ...props }) => (
  <button
    type="submit"
    {...props}
    disabled={props.disabled || loading}
    className={cn(
      'group w-full h-11 rounded-xl bg-[#1F47D6] text-white text-[14.5px] font-semibold inline-flex items-center justify-center gap-2',
      'shadow-[0_8px_20px_-8px_rgba(31,71,214,0.7)] transition-[background-color,transform,box-shadow] duration-200',
      'hover:bg-[#1A3DBD] hover:shadow-[0_10px_24px_-8px_rgba(31,71,214,0.8)] active:scale-[0.99]',
      'disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-[#1F47D6]',
      className,
    )}
  >
    {loading ? (<><Loader2 className="w-4 h-4 animate-spin" />{loadingLabel}</>) : children}
  </button>
);

export const GhostButton = ({ children, className, ...props }) => (
  <button
    type="button"
    {...props}
    className={cn('h-10 rounded-xl border border-slate-200 bg-white text-[13.5px] font-semibold text-slate-700 hover:border-slate-300 hover:bg-slate-50 transition-colors', className)}
  >
    {children}
  </button>
);
